import { render, staticRenderFns } from "./AudioInput.vue?vue&type=template&id=6a61be3c&"
import script from "./AudioInput.vue?vue&type=script&lang=js&"
export * from "./AudioInput.vue?vue&type=script&lang=js&"
import style0 from "./AudioInput.vue?vue&type=style&index=0&id=6a61be3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports